export const LoanDocumentsTreeNodeType = {
  DOCUMENT_CATEGORY: 'document-category-node',
  DOCUMENT_TYPE: 'document-type-node',
  DOCUMENT_ITEM: 'document-item-node',
};

export const DOCUMENT_LABEL_TOOLTIP_POPPER_PROPS = { disablePortal: false };
